import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { openCookieSettings } from "@/components/CookieConsent";

const navLinks = [
  { key: "products", to: "/produse" },
  { key: "services", to: "/servicii" },
  { key: "communities", to: "/comunitate" },
  { key: "capital", to: "/anunturi?mk_primary=oxo-capital" },
  { key: "contact", to: "/contact" },
];

const catLinks = [
  { key: "primary", to: "/produse?cat=01" },
  { key: "secondary", to: "/produse?cat=02" },
  { key: "energy", to: "/produse?cat=30" },
  { key: "tools", to: "/produse?cat=20" },
  { key: "crafts", to: "/arva-szakmak" },
];

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-slate-900 text-slate-300 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 bg-orange-600 flex items-center justify-center">
              <span className="text-white font-black tracking-tighter">OXO</span>
            </div>
            <div className="leading-none">
              <div className="font-black text-white text-lg tracking-tighter" data-testid="footer-logo-main">{t("logo_main_text")}</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mt-1" data-testid="footer-logo-tagline">{t("logo_tagline")}</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">{t("hero_subtitle")}</p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-5">{t("footer_nav_title")}</h4>
          <ul className="space-y-3 text-sm">
            {navLinks.map((l) => (
              <li key={l.key}>
                <Link to={l.to} className="hover:text-orange-500 transition-colors" data-testid={`footer-nav-${l.key}`}>{t(`nav_links.${l.key}`)}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-5">{t("footer_cat_title")}</h4>
          <ul className="space-y-3 text-sm">
            {catLinks.map((l) => (
              <li key={l.key}>
                <Link to={l.to} className="hover:text-orange-500 transition-colors" data-testid={`footer-cat-${l.key}`}>{t(`cat_links.${l.key}`)}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-5">{t("nav_links.contact")}</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-orange-500 shrink-0" /> <a href={`tel:${t("footer_contact_phone").replace(/\s/g, "")}`} className="hover:text-orange-500 transition-colors" data-testid="footer-contact-phone">{t("footer_contact_phone")}</a></li>
            <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-orange-500 shrink-0" /> <a href={`mailto:${t("footer_contact_email")}`} className="hover:text-orange-500 transition-colors" data-testid="footer-contact-email">{t("footer_contact_email")}</a></li>
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" /> <span data-testid="footer-contact-address">{t("footer_contact_address")}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-6 text-xs text-slate-500 flex flex-col sm:flex-row justify-between items-center gap-3">
          <span>© {new Date().getFullYear()} OXO SRL · RO6926354.</span>
          <div className="flex items-center gap-5">
            <Link to="/termeni-si-conditii" className="hover:text-orange-500 transition-colors" data-testid="footer-terms">{t("legal.terms")}</Link>
            <Link to="/confidentialitate" className="hover:text-orange-500 transition-colors" data-testid="footer-privacy">{t("legal.privacy")}</Link>
            <Link to="/politica-retur" className="hover:text-orange-500 transition-colors" data-testid="footer-refund">{t("legal.refund")}</Link>
            <button type="button" onClick={openCookieSettings} className="hover:text-orange-500 transition-colors" data-testid="footer-cookie-settings">{t("cookie.manage")}</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
